/* eslint-disable */
( function ( $ ) {
	'use strict';

	const $folderTitle = $( '.folder-teasers__item-action' );
	const $folderContent = $( '.folder-teasers__item-content' );
	const $folders = $( '.folder-teasers__item' );

	const handleClick = function () {

		let windowWidth = window.innerWidth;
		const $this = $( this );

		if ( 1024 > windowWidth ) {

			if ( $this.parent().hasClass( 'folder-open' ) ) {
				return;
			} else {
				$folders.removeClass( 'folder-open' );
				$folderContent.slideUp();
				$this.parent().addClass( 'folder-open' );
				$this.parent().find( '.folder-teasers__item-content' ).slideDown( '100' );
			}

		} else {
			if ( $this.parent().hasClass( 'folder-open' ) ) {
				return;
			} else {
				$folders.removeClass( 'folder-open' );
				$this.parent().addClass( 'folder-open' );
				$folders.not('.folder-open').find('.folder-teasers__item-content').css("display", "none");
				$this.parent().find( '.folder-teasers__item-content' ).css("display", "block");
			}
		}
	}

	/* Event Handlers */
	if ( 0 < $folders.length ) {
		$folders.first().find( '.folder-teasers__item-content' ).show();
		$folders.first().addClass( 'folder-open' );/**open first folder**/
		$folderTitle.on( 'click', handleClick );/**on click**/
	}

} )( jQuery );
/* eslint-enable */
